import React, { Component } from "react";
import { FontIcon } from "office-ui-fabric-react/lib/Icon";
import { Toggle } from "office-ui-fabric-react/lib/Toggle";
import { Modal } from "office-ui-fabric-react/lib/Modal";
import { Separator } from "office-ui-fabric-react/lib/Separator";
import {
  Callout,
  DefaultButton,
  PrimaryButton,
  getTheme,
  mergeStyleSets,
  FontWeights,
  IconButton,
  ContextualMenu,
  Spinner,
  SpinnerSize,
} from "office-ui-fabric-react";

import { EventEmitter } from "./events";
import "isomorphic-fetch";
import "./../styles/offices.css";

const theme = getTheme();
const contentStyles = mergeStyleSets({
  container: {
    display: "flex",
    flexFlow: "column nowrap",
    alignItems: "stretch",
  },
  header: [
    // tslint:disable-next-line:deprecation
    theme.fonts.xLargePlus,
    {
      flex: "1 1 auto",
      borderTop: `4px solid ${theme.palette.themePrimary}`,
      color: theme.palette.neutralPrimary,
      display: "flex",
      alignItems: "center",
      fontWeight: FontWeights.semibold,
      padding: "12px 12px 14px 24px",
    },
  ],
  body: {
    flex: "4 4 auto",
    padding: "0 24px 24px 24px",
    overflowY: "hidden",
    selectors: {
      p: { margin: "14px 0" },
      "p:first-child": { marginTop: 0 },
      "p:last-child": { marginBottom: 0 },
    },
  },
});

interface IOffices {
  updateURL: string;
  getofficeURL: string;
  useremail: string;
}

class Offices extends Component<IOffices> {
  constructor(props: any) {
    super(props);

    this.state = {
      openDialog: false,
      items: [],
      blocking: true,
      getOfficeURL: "",
      updateOfficeURL: "",
    };

    EventEmitter.subscribe("open-offices", () => {
      this.setState({ openDialog: true }, this.onFetchPreferredOffices);
    });
  }

  onFetchPreferredOffices = () => {
    fetch(
      this.props.getofficeURL + "?tenantid=3&username=" + this.props.useremail
    )
      .then((response) => response.json())
      .then((records) => {
        this.setState({
          items: records,
          blocking: false,
        });
      });
  };

  toggleOffice = (item) => {
    const updatedItems = [...this.state.items].map((inItem) => {
      let retval = item.logonUser ? "" : this.props.useremail;
      return inItem.officeId === item.officeId
        ? Object.assign(inItem, { logonUser: retval })
        : inItem;
    });
    this.setState({ items: updatedItems });
  };

  onCloseDialog = () => {
    this.setState({ openDialog: false });
  };

  onSubmit = () => {
    let reqParam = {
      username: this.props.useremail,
      offices: this.state.items,
    };

    this.setState({ blocking: true });

    fetch(this.props.updateURL, {
      method: "POST",
      body: JSON.stringify(reqParam),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response)
      .then((records) => {
        this.setState({
          openDialog: false,
        });
      });
  };

  _renderItems = () => {
    return this.state.items.map((item, index) => {
      return (
        <div key={index} className="content-offices-item">
          <Toggle
            className="enabled-office"
            checked={item.logonUser ? true : false}
            onChange={() => {
              this.toggleOffice(item);
            }}
          />
          <div className="office-name">{item.officeName}</div>
        </div>
      );
    });
  };

  render() {
    return (
      <Modal
        titleAriaId="title"
        isOpen={this.state.openDialog}
        onDismiss={this.onCloseDialog}
        isBlocking={false}
        containerClassName={contentStyles.container}
      >
        {this.state.blocking === true ? (
          <Spinner
            className="spinner"
            size={SpinnerSize.large}
            label="Loading..."
            ariaLive="assertive"
            labelPosition="top"
          />
        ) : (
          ""
        )}
        <div className="preferred-offices-dialog">
          <Separator className="preferred-offices-header" />
          <div className={contentStyles.header}>
            <span className="title">Select Office</span>
            <IconButton
              styles={{
                root: {
                  color: theme.palette.neutralPrimary,
                  marginLeft: "auto",
                  marginTop: "4px",
                  marginRight: "2px",
                },
                rootHovered: {
                  color: theme.palette.neutralDark,
                },
              }}
              iconProps={{ iconName: "Cancel" }}
              ariaLabel="Close popup modal"
              onClick={this.onCloseDialog}
            />
          </div>
          <div className={contentStyles.body}>
            <div className="preferred-offices-content">
              {this._renderItems()}
            </div>
          </div>
          <div className="content-offices-action-holder">
            <PrimaryButton text="Save" onClick={this.onSubmit} />
            <DefaultButton onClick={this.onCloseDialog} text="Close" />
          </div>
        </div>
      </Modal>
    );
  }
}

export default Offices;
